import { connect } from "react-redux";
import { cloneDeep } from "lodash";

import Select from "react-select";

import { PlusCircleIcon, MinusCircleIcon } from "@heroicons/react/20/solid";

import { Actions as ACTIONS } from '../../../store/actions/leaveActions';


const OccupationalLeaveRuleApplyTo = ({
	updateField,
	addPart,
	removePart,
	applyTo,
	isOptions,
	partIndex,
	lastPart,
	whenOptions,
	condition,
	conditionToggle,
}) => {
	return (
		<div className={`col-xs-12 ${partIndex ? 'p-0 pt-5' : 'p-0'}`}>
			<div className="col-xs-1 p-0">
				{partIndex > 0 ? (
					<label className={"pull-right"}>And</label>
				): <label className={"pull-right"}>When</label>}
			</div>
			<div className="col-xs-4">
				<Select
					name="when"
					options={whenOptions}
					placeholder="Choose One"
					value={whenOptions?.find((i) => i.value == applyTo.when)}
					onChange={(e) => {
						updateField("when", e?.value);
						// reset the value when the when changes
						updateField("value", null);
					}}
				/>
			</div>
			<div className="col-xs-1 text-center "
				style={{
					cursor: conditionToggle ? "pointer" : "default",
				}}
				onClick={() => {
					if (conditionToggle) {
						updateField("condition", condition === "Is" ? "Is not" : "Is");
					}
				}}
			>
				{applyTo.when != "all" && (
					<span style={{
						fontWeight: 600,
						display: 'inline-block',
						fontSize: "13px",
						lineHeight: "15px",
						cursor: conditionToggle ? "pointer" : "default",
					}}
					>{condition}</span>
				)}
            </div>
			<div className="col-xs-5">
				{applyTo.when != "all" && (
				
					conditionToggle ? (
						<Select
							name="Is"
							isClearable={true}
							isMulti={true}
							options={isOptions}
							placeholder="Choose One"
							value={isOptions?.filter((i) => applyTo?.value?.includes(i.value))}
							onChange={(e) => {
								updateField("value", e.map(r => r.value) || null);
							}}
						/>
					) : (
						<div
							className="input-group"
							style={{zIndex: 0}}
						>
								
							<input
								type="number"
								className="form-control"
								style={{ height: "39px", minWidth: "30px", paddingLeft: 10 }}
								value={applyTo?.value}
								onChange={(e) => {
									updateField("value", e.target.value);
								}}
							/>
							<span
								className={`input-group-addon "}`}
								style={{
									padding: "0 5px",
									border: "none",
									lineHeight: "38px",
									width: "29px",
									textAlign: "center",
									userSelect: "none",
								}}
							>
								<span style={{ width: "100%", userSelect: "none" }}>Months</span>
							</span>
						</div>
					)
				
				)}
			</div>
			<div className="col-xs-1"
				 style={{
					display: "flex",
					padding: 0,
					// justifyContent: "space-between",
					justifyContent: "flex-end",
					 marginTop: '0.5em'
				 }}
			>

				{/*<MinusCircleIcon
						onClick={() => removePart()}
						className={"text-white"}
						style={{ height: "2.5rem", float: "left", fill:"#e83e36", cursor: "pointer"}}
					/>*/}
				<button
					className="btn btn-danger pull-left"
					style={{ padding: 3 }}
					type="button"
					onClick={() => removePart()}
				>
					<MinusCircleIcon style={{ height: "1.3em", float: "left" }} />
				</button>
				{ lastPart && applyTo.when != "all" && (

						/*<PlusCircleIcon
							onClick={() => addPart()}
							className={"text-white"}
							style={{ height: "2.5rem", float: "left", fill:"#00bb87", cursor: "pointer"}}
						/>*/
					<button
						className="btn btn-success pull-left"
						style={{ padding: 3 }}
						type="button"
						onClick={() => addPart()}
					>
						<PlusCircleIcon
							style={{ height: "1.3em", float: "left"}}
						/>
					</button>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state,ownProps) => {

	const partIndex = ownProps.partIndex;
	const applyToParts = state.leave.rules.find(r => r.id === ownProps.id).applyTo

	const applyTo = ownProps.applyTo


	// TODO EE + DEPT options should be saved in redux to reduce the number of times we calculate this
	const employees = state?.employees?.employeeListWithSalary || [];

	// map the employees to the format that the Select component expects
		// include the reference number in the label or idNo / NIC number
	const employeeOptions =
		employees?.map((employee) => (
			{
				label: `${employee?.employeeName} ${employee?.employeeSurname} (${employee?.reference ?? employee?.idNo ?? employee?.NIC})`,
				value: employee.id
			}
		));

	const departments = state?.company?.settings?.departments || [];

	const departmentOptions = departments.map((department) => ({ label: department?.name, value: department.id }));

	const uniqueRoles = [...new Set(employees.map(e => e?.roleName))];
	const roleOptions = uniqueRoles.map((role) => ({ label: role, value: role }));

	const whenOptions = [
		{
			label: "Everyone",
			value: "all",
		},
		{
			label: "Employee",
			value: "employee",
		},
		{
			label: "Department",
			value: "department",
		},
		{
			label: "Role",
			value: "role",
		},
		{
			label: "Service Length",
			value: "serviceLength",
		},
	];

	let isOptions = []

	// pay items are company allowances and deductions
	const payItems = state?.company?.settings?.allowances || [];
	const payItemOptions = payItems.map((payItem) => ({ label: payItem?.name, value: payItem.id }));

	let condition = applyTo?.condition ?? "Is";
	let conditionToggle = true;

	switch (applyTo?.when) {
		case "employee":
			isOptions = employeeOptions;
			break;
		case "department":
			isOptions = departmentOptions;
			break;
		case "role":
			isOptions = roleOptions;
			break;
		case "serviceLength":
			condition = 'Greater than';
			conditionToggle = false;
			break;

		// case "Role": return employeeOptions;
	}


	return {
		applyTo,
		isOptions,
		// return only options that are not used in other parts
		whenOptions: whenOptions.filter((i) => !applyToParts.map((p, index) => index != partIndex && p.when).includes(i.value)),
		condition,
	    conditionToggle,
	}

};

const mapDispatchToProps = (dispatch,ownProps) => ({
	updateField: (field, value) => dispatch(ACTIONS.updateLeaveRule({
        field: `applyTo.${ownProps.partIndex}.${field}`,
        value,
        id: ownProps?.id
    })),
	addPart: () => dispatch(ACTIONS.updateLeaveRule({
        field: `applyTo.${ownProps.partIndex + 1}`,
        value: {},
        id: ownProps?.id
    })),
	removePart: () => dispatch(ACTIONS.updateLeaveRule({
        field: `applyTo.${ownProps.partIndex}`,
        action: "remove",
        id: ownProps?.id
    })),
});

export default connect(mapStateToProps, mapDispatchToProps)(OccupationalLeaveRuleApplyTo);
